import React from "react";

/** Iter209er — Riepilogo "Sopralluogo saltato" (la scelta avviene nello stage qty_visit). */
export default function SkipVisitBlock({
  canSkipVisit = false,
  visitSkipped = false,
  skipVisitNote = "",
}) {
  if (!canSkipVisit || !visitSkipped) return null;
  return (
        <div
          className={`rounded-md border-2 p-3 text-sm ${visitSkipped ? "border-amber-300 bg-amber-50" : "border-slate-200 bg-slate-50/50"}`}
          data-testid="skip-visit-block"
        >
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="font-semibold text-amber-900">✅ Sopralluogo saltato</div>
                <div className="text-xs text-amber-800 mt-0.5">
                  Hai accettato il rischio: Housetag e i tecnici non saranno responsabili per errori dovuti alla mancanza del sopralluogo.
                </div>
              </div>
            </div>
          {skipVisitNote && (
            <div className="mt-2 text-xs text-slate-700 bg-white/70 border border-slate-200 rounded px-2 py-1.5" data-testid="skip-visit-note">
              <span className="font-semibold">Nota:</span> {skipVisitNote}
            </div>
          )}
        </div>
  );
}
